<template>

<v-row justify="center">
    <v-dialog v-model="abrir" fullscreen hide-overlay transition="dialog-bottom-transition">
      
      <v-card>

        <v-toolbar dark color="green darken-3">
          
          <v-toolbar-title>{{`Configuración de Opciones de Parámetro : ${parametro.nombre_parametro}`}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="abrir = false">
                <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-btn class="mt-5" color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
            </v-btn>
        </v-card-text>
        <!-- tabla de opciones actuales -->
        <v-card-text>
            <v-card>
                <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                    <th class="text-center">Opcion</th>
                    <th class="text-center">Activo</th>
                    <th class="text-center">Editar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="par in opciones" :key="par.id">
                    <td class="text-center">{{ par.opcion }}</td>
                    <td class="text-center">{{ par.activo }}</td>
                    <td class="text-center">
                        <v-btn color="orange darken-4" fab small dark @click="editar(par)">
                            <v-icon>create</v-icon>
                        </v-btn>
                    </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
            </v-card>
        </v-card-text>
        <!-- tabla de opciones actuales -->

      </v-card>
    </v-dialog>

    <!-- modal para crear y editar -->
    <modal @peticionrealizada="cargarDatos"></modal>
    <!-- modal para crear y editar -->

  </v-row>
</template>
<script>
import Modal from '@/components/shared/Modal.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    data:()=>({
        parametro:{},
        abrir:false,
        opciones:[],
        configuracion_modal:{},
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre Opción*',key:'opcion'},
            {tipo:'switch',valor:'1',label:'Activo',key:'activo'},
            {tipo:'hidden',valor:'',key:'parametros_id'}
        ],
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_configuracion_opciones');
    },
    mounted(){
        Event.$on('abrir_modal_configuracion_opciones',(parametro)=>{
            this.parametro = parametro;
            this.inputs[2].valor = this.parametro.id;
            this.opciones = this.parametro.opciones;
            this.abrir = true;
            console.log('parametro_recibido',this.parametro);
        });
    },
    methods: {
        crear(){
            this.configuracion_modal.titulo_modal = 'Crear Opción Parámetro';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'parametro_opciones';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir', this.inputs,this.configuracion_modal);
        },

        async editar(parametro){
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys(parametro).forEach(key => {
                    let valor = parametro[key];
                    if(input.key == key){
                        input.valor = valor
                    }
                });
            });
            this.configuracion_modal.titulo_modal = 'Editar Opción Parámetro';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `parametro_opciones/${parametro.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir', this.inputs,this.configuracion_modal);
        },

        cargarDatos(){
            //this.mostrarLoading('Actualizando Opciones...')
            this.mostrarLoading({titulo:'Actualizando Opciones...',color:'green'})

            let url = `${this.base_url}parametros/${this.parametro.id}/opciones`;
            this.axios.get(url,this.headers).then((res)=>{
                this.opciones = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal
    }
}
</script>